<template>
  <div class="house-statistics">
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="项目级" name="ProjectRoomStatusStatistics">
        <ProjectRoomStatusStatistics v-if="card_index==='ProjectRoomStatusStatistics'" />
      </el-tab-pane>
      <el-tab-pane label="战区级" name="GradingRoomStatusStatistics">
        <GradingRoomStatusStatistics v-if="card_index==='GradingRoomStatusStatistics'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import ProjectRoomStatusStatistics from "./components/ProjectRoomStatusStatistics";
import GradingRoomStatusStatistics from "./components/GradingRoomStatusStatistics";
export default {
  name: "HouseStatistics",
  components: {GradingRoomStatusStatistics, ProjectRoomStatusStatistics},
  data() {
    return {
      card_index: "GradingRoomStatusStatistics"
    }
  }
}
</script>

<style lang="scss" scoped>
.house-statistics {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/HouseStatistics.vue